import React from "react";

const Settings: React.FC = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1019 1.36893H15.2335V7.77928H22.6666V12.913H16.4599L22.0754 19.8231L18.0935 23.0615L12.6628 16.3786L7.23434 23.0586L3.25252 19.8202L8.86563 12.913H2.66663V7.77928H10.1019V1.36893Z"
        fill="#101111"
      />
    </svg>
  );
};

export default Settings;
